import { MouseEventHandler } from 'react';
import styled from 'styled-components';

import { StyledFlex } from '@dreryk/react-components';

const StyledDiscardIcon = styled(StyledFlex)`
   cursor: pointer;
`;

type DiscardIconProps = { onClick?: MouseEventHandler };

export const DiscardIcon = (props: DiscardIconProps): JSX.Element => (
   <StyledDiscardIcon onClick={props.onClick}>
      <svg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
         <rect x='1' y='1' width='30' height='30' rx='15' stroke='#589AE9' strokeWidth='2' />
         <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M11 21.8333C11 22.75 11.75 23.5 12.6667 23.5H19.3333C20.25 23.5 21 22.75 21 21.8333V11.8333H11V21.8333ZM21.8333 9.33333H18.9167L18.0833 8.5H13.9167L13.0833 9.33333H10.1667V11H21.8333V9.33333Z'
            fill='#589AE9'
         />
      </svg>
   </StyledDiscardIcon>
);
